import { render, staticRenderFns } from "./GameRSM.vue?vue&type=template&id=298b5ea8&"
import script from "./GameRSM.vue?vue&type=script&lang=js&"
export * from "./GameRSM.vue?vue&type=script&lang=js&"
import style0 from "./GameRSM.vue?vue&type=style&index=0&id=298b5ea8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports